module.exports = __webpack_public_path__ + "static/images/biditem5_f0b80565.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem5.png
// module id = 244
// module chunks = 1